"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trim = void 0;
/**
 * Obcina początkowe i końcowe spacje w tekscie
 * @param text tekst do obcięcia
 */
function trim(text) {
    return (text || '').trim();
}
exports.trim = trim;
exports.default = trim;
//# sourceMappingURL=trim.js.map